import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const FadingMessage = ({ message, delay }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: visible ? 1 : 0 }}
      transition={{ duration: 1 }} // Adjust the duration as needed
      style={{ display: visible ? "block" : "none" }} // Hide after fade-out
      className="mb-8 paragraph-small-regular text-primary-900 px-4 py-3 bg-primary-50 dark:bg-secondary-800 rounded-[8px] my-[16px] border border-indigo-200 dark:border-primary-900"
    >
      {message}
    </motion.div>
  );
};

export default FadingMessage;
